module.exports = __webpack_public_path__ + "img/logo.aafe5bed.png";